import * as React from 'react';
import * as styles from './styles.css';

import { FormHeader } from '../FormHeader';
import { IMainScreenProps } from '../..';

export function MainScreenMobile(props: IMainScreenProps) {
  const { backToPage, progressBar, main, showGoBackBtn, handleGoBack, goBackText } = props;

  return (
    <div className={styles['container']}>
      <div>
        <FormHeader
          backToPage={backToPage}
          progressBar={progressBar}
          showGoBackBtn={showGoBackBtn}
          handleGoBack={handleGoBack}
          goBackText={goBackText}
        />
      </div>
      <div className={styles['content']}>{main}</div>
    </div>
  );
}
